<template>
  <div class="container">
    <div class="calculo-container" style="background:#fff; padding:0px;">
      <topOp />
      <div class="div-titulo">
        <h3 class="titulo">Cálculo Seguro Desemprego</h3>
      </div>

      <div class="inputs">
        <label for="causa-rescisao">Selecione a Causa da Rescisão</label>
        <select
          id="causa-rescisao"
          v-model="causaRescisao"
          @change="validaCausaRescisao"
        >
          <option value="demissao-sem-justa-causa"
            >Demissão sem justa causa</option           
          >
          
          <option value="pedido-demissao">Pedido de demissão</option>
          <option value="termino-contrato"
            >Rescisão por término de contrato a termo</option
          >
        </select>
        <!-- <p v-if="causaRescisao === 'demissao-sem-justa-causa'" class="nota-retomada"><span style="color: #ff7835">Nota:</span> Art. 37. Será assegurado o direito ao recebimento do benefício ou a retomada do saldo de parcelas quando ocorrer a suspensão motivada por reemprego,
 desde que o motivo da dispensa não seja a pedido ou por justa causa, dentro do mesmo período aquisitivo.</p> -->
        <div v-if="erroCausaRescisao" class="feedback-causa-rescisao">
          {{ erroCausaRescisao }}
        </div>

        <label for="tipo">Selecione o tipo:</label>
        <select
          id="tipo"
          v-model="tipo"
          :disabled="
            causaRescisao === 'pedido-demissao' ||
              causaRescisao === 'termino-contrato'
          "
        >
          <option value="formal">Seguro Desemprego Formal</option>
          <option value="domestico"
            >Seguro Desemprego Doméstico (cálculo simplificado)</option
          >
        </select>

        <label for="ja-recebeu">Recebeu seguro desemprego anteriormente?</label>
        <select
          id="ja-recebeu"
          v-model="jaRecebeu"
          :disabled="
              causaRescisao === 'pedido-demissao' ||
              causaRescisao === 'termino-contrato'
          "
        >
          <option value="nao">Não, primeira solicitação</option>
          <option value="sim-segunda">Sim, segunda solicitação</option>
          <option value="sim-terceira-mais"
            >Sim, terceira ou mais solicitações</option
          >
        </select>

        <div v-if="jaRecebeu !== 'nao'" class="input-carencia">
          <label for="respeita-carencia"
            >A dispensa que gerou o último seguro ocorreu há mais de 16
            meses?</label
          >
          <select
            id="respeita-carencia"
            v-model="respeitaCarencia"
            :disabled="
              causaRescisao === 'pedido-demissao' ||
                causaRescisao === 'termino-contrato'
            "
          >
            <option value="sim">Sim, ocorreu há 16 meses ou mais</option>
            <option value="nao">Não, ocorreu há menos de 16 meses</option>
          </select>
          <div v-if="respeitaCarencia === 'nao'" class="feedback erro">
            Não tem direito ao benefício. É necessário um intervalo de pelo
            menos 16 meses entre a data de demissão atual e a demissão que gerou
            o benefício anterior.
          </div>
        </div>

        <label for="antepenultimo-salario">Antepenúltimo salário R$:</label>
        <input
          type="text"
          id="antepenultimo-salario"
          @keypress="permitirSomenteNumeros($event)"
          :value="formatarMoeda(antepenultimoSalario)"
          @input="onInputSalario($event, 'antepenultimoSalario')"
          :disabled="
            tipo === 'domestico' ||
              causaRescisao === 'pedido-demissao' ||
              causaRescisao === 'termino-contrato' ||
              respeitaCarencia === 'nao'
          "
        />

        <label for="penultimo-salario">Penúltimo salário R$:</label>
        <input
          type="text"
          id="penultimo-salario"
          @keypress="permitirSomenteNumeros($event)"
          :value="formatarMoeda(penultimoSalario)"
          @input="onInputSalario($event, 'penultimoSalario')"
          :disabled="
            tipo === 'domestico' ||
              causaRescisao === 'pedido-demissao' ||
              causaRescisao === 'termino-contrato' ||
              respeitaCarencia === 'nao'
          "
        />

        <label for="ultimo-salario">Último salário R$:</label>
        <input
          type="text"
          id="ultimo-salario"
          @keypress="permitirSomenteNumeros($event)"
          :value="formatarMoeda(ultimoSalario)"
          @input="onInputSalario($event, 'ultimoSalario')"
          :disabled="
            tipo === 'domestico' ||
              causaRescisao === 'pedido-demissao' ||
              causaRescisao === 'termino-contrato' ||
              respeitaCarencia === 'nao'
          "
        />

        <label for="meses-trabalhados"
          >Número de meses trabalhados nos últimos 36 meses:</label
        >
        <input
          type="number"
          id="meses-trabalhados"
          @keypress="permitirSomenteNumeros($event)"
          placeholder="0"
          v-model.number="mesesTrabalhados"
          :disabled="
            causaRescisao === 'pedido-demissao' ||
              causaRescisao === 'termino-contrato' ||
              respeitaCarencia === 'nao'
          "
        />
      </div>

      <div v-if="isLoading" class="feedback">
        Carregando regras de cálculo...
      </div>
      <div v-if="erro" class="feedback erro">{{ erro }}</div>

      <div class="botoes">
        <button class="btn-limpar" @click="limpar">Limpar</button>
        <button
          class="btn-calcular"
          @click="calcular"
          :disabled="
            isLoading ||
              causaRescisao === 'pedido-demissao' ||
              causaRescisao === 'termino-contrato' ||
              respeitaCarencia === 'nao'
          "
        >
          Calcular Seguro
        </button>
      </div>

      <div v-if="loading" class="loading-overlay">
        <div class="spinner"></div>
      </div>
      <div v-else>
        <div
          v-if="resultado"
          class="resultado-container"
          ref="resultadoSection"
        >
          <h4>Resultado do Cálculo:</h4>
          <hr />
          <template
            v-if="tipo === 'domestico' && resultado.quantidadeParcelas === 0"
          >
            <div v-if="resultado.observacao" class="observacao">
              <p><strong>Atenção:</strong> {{ resultado.observacao }}</p>
            </div>
          </template>
          <template v-else>
            <p v-if="tipo === 'formal' && !resultado.observacao">
              <strong>Média Salarial:</strong>
              <span>{{ formatarMoeda(resultado.mediaSalarial) }}</span>
            </p>
            <p v-if="!resultado.observacao">
              <strong>Valor da Parcela:</strong>
              <span>{{ formatarMoeda(resultado.valorParcela) }}</span>
            </p>
            <p v-if="!resultado.observacao">
              <strong>Quantidade de Parcelas:</strong>
              <span>{{ resultado.quantidadeParcelas }}</span>
            </p>
            <p v-if="!resultado.observacao">
              <strong>Total a Receber:</strong>
              <span>{{
                formatarMoeda(
                  resultado.valorParcela * resultado.quantidadeParcelas
                )
              }}</span>
            </p>
            <div v-if="resultado.observacao" class="observacao">
              <p><strong>Atenção:</strong> {{ resultado.observacao }}</p>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import topOp from "../shared/topOp.vue";

export default {
  name: "CalculoSeguroDesemprego",
  components: {
    topOp,
  },
  data() {
    return {
      causaRescisao: "demissao-sem-justa-causa",
      tipo: "formal",
      jaRecebeu: "nao",
      antepenultimoSalario: null,
      penultimoSalario: null,
      ultimoSalario: null,
      mesesTrabalhados: null,
      regrasCalculo: null,
      resultado: null,
      isLoading: false,
      loading: false,
      erro: null,
      erroCausaRescisao: null,
      respeitaCarencia: "sim",
    };
  },
  methods: {
    permitirSomenteNumeros(event) {
      const charCode = event.charCode ? event.charCode : event.keyCode;
      if (charCode < 48 || charCode > 57) {
        event.preventDefault();
        // alert("Por favor, insira apenas números.");
      }
    },

    validaCausaRescisao() {
      if (this.causaRescisao === "pedido-demissao") {
        this.erroCausaRescisao =
          "Pedido de demissão - Não tem direito ao Seguro Desemprego";
        this.resultado = null;
        console.log(
          "Pedido de demissão - Não tem direito ao Seguro Desemprego"
        );
        return false;
      } else if (this.causaRescisao === "termino-contrato") {
        this.erroCausaRescisao =
          "Término de contrato - Não tem direito ao Seguro Desemprego";
        this.resultado = null;
        console.log(
          "Término de contrato - Não tem direito ao Seguro Desemprego"
        );
        return false;
      } else if (this.causaRescisao === "demissao-sem-justa-causa") {
        this.erroCausaRescisao = null;
        return true;
      }
    },

    onInputSalario(event, campo) {
      let valor = event.target.value.replace(/\D/g, "");
      valor = (parseInt(valor, 10) / 100).toFixed(2);
      this[campo] = Number(valor);
    },
    limpar() {
      this.causaRescisao = "demissao-sem-justa-causa";
      this.tipo = "formal";
      this.jaRecebeu = "nao";
      this.antepenultimoSalario = null;
      this.penultimoSalario = null;
      this.ultimoSalario = null;
      this.mesesTrabalhados = null;
      this.resultado = null;
      this.erro = null;
      this.erroCausaRescisao = null;
      this.respeitaCarencia = "sim";
      console.log("Campos limpos.");
    },
    parseCurrency(valorString) {
      if (!valorString) return 0;
      return parseFloat(
        valorString
          .replace("R$ ", "")
          .replace(".", "")
          .replace(",", ".")
      );
    },
    formatarMoeda(valor) {
      if (valor === null || isNaN(valor)) return "R$ 0,00";
      return valor.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
    calcular() {
      this.erro = null;
      if (this.jaRecebeu !== "nao" && this.respeitaCarencia === "nao") {
        this.erro =
          "Não tem direito ao benefício. É necessário um intervalo de pelo menos 16 meses entre a data de demissão atual e a demissão que gerou o benefício anterior.";
        return;
      }
      if (
        this.tipo === "formal" &&
        (!this.antepenultimoSalario ||
          !this.penultimoSalario ||
          !this.ultimoSalario)
      ) {
        this.erro = "Por favor, preencha os valores dos três últimos salários.";
        return;
      }

      if (!this.mesesTrabalhados) {
        this.erro = "Por favor, informe o número de meses trabalhados.";
        return;
      }
      this.loading = true;

      setTimeout(() => {
        if (this.tipo === "domestico") {
          this.loading = false;
          if (!this.regrasCalculo) {
            this.erro = "As regras de cálculo não foram carregadas.";
            return;
          }

          const valorParcelaFinal = this.regrasCalculo.valor;

          const quantidadeParcelas = this.mesesTrabalhados >= 15 ? 3 : 0;
          const observacao =
            quantidadeParcelas > 0
              ? null
              : "Para o benefício do empregado doméstico, são necessários no mínimo 15 meses de trabalho nos últimos 24 meses.";

          this.$nextTick(() => {
            this.$refs.resultadoSection.scrollIntoView({ behavior: "smooth" });
          });
          this.resultado = {
            mediaSalarial: 0,
            valorParcela: valorParcelaFinal,
            quantidadeParcelas: quantidadeParcelas,
            observacao: observacao,
          };
          console.log("Resultado do cálculo:", this.resultado);
          return;
        }

        if (!this.regrasCalculo) {
          this.erro =
            "As regras de cálculo não foram carregadas. Verifique sua conexão.";
          return;
        }

        const mediaSalarial =
          (this.antepenultimoSalario +
            this.penultimoSalario +
            this.ultimoSalario) /
          3;

        const {
          faixa1_limite,
          faixa2_fim,
          parcela_adicional,
          parcela_fixa_maxima,
          valor: salarioMinimo,
        } = this.regrasCalculo;
        const limite1 = this.parseCurrency(faixa1_limite);
        const limite2 = this.parseCurrency(faixa2_fim);
        const adicional = this.parseCurrency(parcela_adicional);
        const maximo = this.parseCurrency(parcela_fixa_maxima);
        const minimo = salarioMinimo;

        let valorParcelaCalculado = 0;

        if (mediaSalarial <= limite1) {
          valorParcelaCalculado = mediaSalarial * 0.8;
        } else if (mediaSalarial <= limite2) {
          valorParcelaCalculado = (mediaSalarial - limite1) * 0.5 + adicional;
        } else {
          valorParcelaCalculado = maximo;
        }

        const valorParcelaFinal = Math.max(valorParcelaCalculado, minimo);

        let quantidadeParcelas = 0;
        let observacao = null;
        const meses = this.mesesTrabalhados;

        switch (this.jaRecebeu) {
          case "nao":
            if (meses >= 12 && meses <= 23) quantidadeParcelas = 4;
            else if (meses >= 24) quantidadeParcelas = 5;
            else
              observacao =
                "Para a 1ª solicitação, são necessários no mínimo 12 meses de trabalho.";
            break;
          case "sim-segunda":
            if (meses >= 9 && meses <= 11) quantidadeParcelas = 3;
            else if (meses >= 12 && meses <= 23) quantidadeParcelas = 4;
            else if (meses >= 24) quantidadeParcelas = 5;
            else
              observacao =
                "Para a 2ª solicitação, são necessários no mínimo 9 meses de trabalho.";
            break;
          case "sim-terceira-mais":
            if (meses >= 6 && meses <= 11) quantidadeParcelas = 3;
            else if (meses >= 12 && meses <= 23) quantidadeParcelas = 4;
            else if (meses >= 24) quantidadeParcelas = 5;
            else
              observacao =
                "Para a 3ª solicitação ou mais, são necessários no mínimo 6 meses de trabalho.";
            break;
        }

        if (quantidadeParcelas === 0 && !observacao) {
          observacao =
            "Com os dados informados, o trabalhador não tem direito ao benefício.";
        }

        this.resultado = {
          mediaSalarial,
          valorParcela: valorParcelaFinal,
          quantidadeParcelas,
          observacao,
        };
        console.log("Resultado do cálculo:", this.resultado);

        this.loading = false;
        this.$nextTick(() => {
          this.$refs.resultadoSection.scrollIntoView({ behavior: "smooth" });
        });
      }, 1500);
      console.log("Cálculo realizado com sucesso.");
    },
  },

  async mounted() {
    this.isLoading = true;
    this.erro = null;
    try {
      const response = await axios.get(
        "https://www.lefisc.com.br/api/CalculosTrabalhistas/calculos/seguro-desemprego/a5ec945de42672e03b563faa32f01a90"
      );
      this.regrasCalculo = response.data;
    } catch (error) {
      console.error("Erro ao buscar dados da API:", error);
      this.erro =
        "Não foi possível carregar as regras de cálculo. Tente novamente mais tarde.";
    } finally {
      this.isLoading = false;
    }
  },
};
</script>

<style>
.div-titulo {
  padding-left: 110px;
  padding-right: 110px;
  padding-bottom: 25px;
}
.titulo {
  font-style: italic;
  font-weight: 700;
  border-bottom: 1px solid #707070;
  padding-bottom: 15px;
  text-align: left;
  font-size: 26px;
}
.nota-retomada {
  text-align: left;
  font-size: 14px;
}
.inputs {
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 20px;
  justify-content: center;
  max-width: 400px;
  margin: 0 auto;
}
.inputs label {
  text-align: left;
  margin-bottom: 1px;
  font-weight: 500;
}
.inputs input,
.inputs select {
  margin-bottom: 15px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
}
.input-carencia {
  display: flex;
  flex-direction: column;
  gap: 5px;
  justify-content: center;
  max-width: 400px;
  margin: 0 auto;
}
.botoes {
  display: flex;
  padding: 20px;
  padding-top: 5px;
  gap: 5px;
  justify-content: space-between;
  max-width: 400px;
  margin: 0 auto;
  margin-bottom: 40px;
}
.btn-calcular,
.btn-limpar {
  color: white;
  padding: 12px 25px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
}
.btn-calcular {
  background-color: #f7b733;
}
.btn-limpar {
  background-color: #707070;
}
.btn-calcular:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
.feedback {
  text-align: center;
  padding: 10px;
  margin: 0 20px 20px;
  border-radius: 5px;
}
.erro {
  background-color: #ffdddd;
  color: #d8000c;
  border: 1px solid #d8000c;
  max-width: 400px;
  margin: 0 auto;
  margin-bottom: 30px;
}
.feedback-causa-rescisao {
  background-color: #ffdddd;
  color: #d8000c;
  border: 1px solid #d8000c;
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 30px;
  font-weight: bold;
  margin-top: 5px;
  text-align: center;
}
.resultado-container {
  margin: 20px auto;
  padding: 20px;
  background-color: #faf0db;
  border-left: 5px solid #f7b733;
}
.resultado-container h4 {
  margin-top: 0;
  border-bottom-width: 50%;
}
.resultado-container p {
  font-size: 18px;
}
.resultado-container span {
  font-weight: bold;
  font-size: 20px;
  color: #ff7835;
}
hr {
  width: 35%;
  border: 1px solid #ccc;
  margin-bottom: 25px;
}
.observacao {
  margin-top: 15px;
  padding: 10px;
  background-color: #fff3cd;
  border-left: 4px solid #ffeeba;
  color: #856404;
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.spinner {
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top: 4px solid white;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/CalculoSeguroDesemprego.vue